import React from 'react'
import { Skeleton } from 'antd'

import MemberHealthCardSkeleton from './MemberHealthCardSkeleton'
import layout from './ProjectHealthDashboard.module.css'
import sk from './ReportSkeleton.module.css'

const MEMBER_PLACEHOLDER_COUNT = 4

const MemberHealthListSkeleton = () => (
    <section className={`${layout.membersSection} ${sk.skeletonBlock}`} aria-hidden>
        <div className={layout.membersSectionHeader}>
            <div>
                <Skeleton.Input active className={sk.sectionTitleSk} />
                <Skeleton.Input active className={sk.sectionSubtitleSk} />
            </div>
            <Skeleton.Input active className={sk.memberSearchSk} />
        </div>
        <div className={layout.memberList}>
            {Array.from({ length: MEMBER_PLACEHOLDER_COUNT }).map((_, index) => (
                <MemberHealthCardSkeleton key={index} />
            ))}
        </div>
    </section>
)

export default MemberHealthListSkeleton
